import {
  yleConsentSdkHeadless,
  Environment,
} from '@yleisradio/consent-sdk/headless';
import { useCallback } from 'react';
import { isTestRuntime } from '../../common/utils';

const isTestRunner = () => typeof jest !== 'undefined';

export const useYleConsentSdk = () => {
  const initConsentSdk = async (vrsDevice: string) => {
    const environment: Environment = isTestRuntime() ? 'test' : 'prod';
    const args = {
      environment,
      initiatingApp: vrsDevice,
    };

    if (!yleConsentSdkHeadless?.initialized && !isTestRunner()) {
      await yleConsentSdkHeadless?.init(args);
    }
  };

  return {
    initConsentSdk: useCallback(initConsentSdk, []),
  };
};
